export const playingConditionHtml = `
<style>
.pc-content {
    font-family: var(--fontBody), "Inter", sans-serif;
    color: #333;
    line-height: 1.8;
}
.pc-content p {
    margin-bottom: 1em;
}
.pc-content h1, .pc-content h2, .pc-content h3, .pc-content h4 {
    color: var(--blue);
    font-family: var(--fontDisplay), "Oswald", sans-serif;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
}
.pc-content td {
    padding: 8px;
    border: 1px solid #ddd;
}
.pc-content table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1em;
}
</style>
<div class="pc-content">


<p class="p5">British Tamil Cricket League</p>
<p class="p5"><span class="s1">LEAGUE PLAYING CONDITIONS 16</span></p>

<p class="p5">Players and officials must read &amp; understand the BTCL Playing Conditions to ensure clarity and uphold the league's integrity, fostering confidence in fair play.</p>

<p class="p7">The laws of cricket shall apply. All other variations are included in the League Playing Conditions.</p>
<p class="p5">(<span class="s1">https://www.lords.org/mcc/the-laws-of-cricket</span>)</p>

<p class="p9">Document history</p>
<p class="p10">This document has been issued and amended as follows:</p>
<table cellspacing="0" cellpadding="0" class="t1">
  <tbody>
    <tr>
      <td valign="middle" class="td1">
        <p class="p11">Version</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p11">Date</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p11">Description</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p11">Created by</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p11">Approved by</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">1.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">2011</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">First Issue</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p13">BTCL- Member Clubs</p>
        
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">2.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">21/04/2012</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Modified by AGM decisions</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">3.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">22/04/2013</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Accepted at Special AGM on 13/04/2013</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">3.1</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">23/04/2013</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Umpire fees update as agreed in 2012, but mistakenly left (8.15 Section e), Section 8.8 order changed for clarity.</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">4.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">06/04/2014</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Discussed at SGM &amp; updated based on BTCL-COM decisions</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">5.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">20/04/2015</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Modified by</p>
        <p class="p12">AGM/SGM decisions</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">6.0</p>
        
      </td>
      <td valign="middle" class="td1">
        <p class="p12">23/04/2016</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Modified by AGM/SGM decisions</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">7.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">25/04/2016</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Modified by</p>
        <p class="p12">AGM/SGM decisions</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">8.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">02/05/2018</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Added ECB law changes in Winter 2017 and changes approved at the AGM/SGM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">9.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">19/04/2019</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Changes approved in AGM/SGM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
        
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">10.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">11/04/2020</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Changes approved at AGM on the 11<sup>th</sup> of April 2021</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">11.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">11/04/2021</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Changes approved at SGM on the 11<sup>th</sup> of April 2021</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">12.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">23/04/2022</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Changes approved at SGM on the 10<sup>th</sup> of April 2022</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">13.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">16/04/2023</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Changes proposed at SGM on 16<sup>th</sup> April 2023</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">14.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">14/04/2024</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">AGM &amp; SGM 2024 Changes</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">15.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">15/03/2025</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">AGM Changes (Dec 2024)</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p12">16.0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">18/04/2025</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">AGM1/2 Changes (Dec 2025)</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-COM</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">BTCL-Member Clubs</p>
      </td>
    </tr>
  </tbody>
</table>

<p class="p15"><b>CONTENTS SUMMARY</b></p>
<p class="p16">1GENERAL<span class="s2">6</span></p>
<p class="p16">2. FIXTURES<span class="s2">6</span></p>
<p class="p16">3. CORRESPONDENCE<span class="s2">6</span></p>
<p class="p16">4. STRUCTURE OF THE LEAGUE<span class="s2">7</span></p>
<p class="p16">5. MEMBERSHIP<span class="s2">7</span></p>
<p class="p16">6. LEAGUE ENTRY FORM &amp; FEE<span class="s2">8</span></p>
<p class="p16">7. FINES AND POINTS REDUCTION<span class="s2">8</span></p>
<p class="p16">8. PLAYER REGISTRATION<span class="s2">10</span></p>
<p class="p16">9. MATCHDAY<span class="s2">12</span></p>
<p class="p16">9.1General<span class="s2">12</span></p>
<p class="p16">9.18Duration of Match<span class="s2">13</span></p>
<p class="p16">9.5Walkover<span class="s2">14</span></p>
<p class="p16">9.6Late Arrival of a Player<span class="s2">14</span></p>
<p class="p16">9.7 Less than 11 Players<span class="s2">15</span></p>
<p class="p16">9.8Over Rates<span class="s2">15</span></p>
<p class="p16">9.9Introducing Power Play<span class="s2">16</span></p>
<p class="p16">9.10Pitch - "Area to be protected”.<span class="s2">16</span></p>
<p class="p16">9.11Matches Affected by Adverse Weather/Ground Conditions<span class="s2">16</span></p>
<p class="p16">9.12 Facilities<span class="s2">17</span></p>
<p class="p16">9.13Fair Play Assessment<span class="s2">18</span></p>
<p class="p16">9.14Match Balls<span class="s2">18</span></p>
<p class="p16">9.15Fielding Restrictions<span class="s2">18</span></p>
<p class="p16">9.16Ground &amp; Facilities Reporting and Inspection<span class="s2">20</span></p>
<p class="p16">9.17General<span class="s2">20</span></p>
<p class="p16">9.18Quality of Match Day Food<span class="s2">20</span></p>
<p class="p16">9.19Umpires and Scorers<span class="s2">20</span></p>
<p class="p16">9.21No Ball/Wide Ball<span class="s2">22</span></p>
<p class="p16">9.22Offensive Language by Player/Umpire<span class="s2">23</span></p>
<p class="p16">9.23Physical Violence of Player(s)/Umpires<span class="s2">23</span></p>
<p class="p16">10. SCORE SHEET UPDATE<span class="s2">23</span></p>
<p class="p16">11. POINTS SYSTEM<span class="s2">23</span></p>
<p class="p16">11.1General<span class="s2">23</span></p>
<p class="p16">11.2Promotion and Relegation<span class="s2">24</span></p>
<p class="p16">12. LEAGUE AWARDS<span class="s2">24</span></p>
<p class="p16">12.1Annual Award Ceremony<span class="s2">24</span></p>
<p class="p16">12.2Awards Selections<span class="s2">24</span></p>
<p class="p16">12.3Division Awards<span class="s2">24</span></p>
<p class="p16">12.4Individual/Team Awards<span class="s2">24</span></p>
<p class="p16">12.5Merit Award Prizes<span class="s2">25</span></p>
<p class="p16">12.6Social Media<span class="s2">25</span></p>
<p class="p16">13. ECB SAFE HANDS POLICY<span class="s2">25</span></p>
<p class="p16">APPENDIX<span class="s2">26</span></p>
<p class="p16">APPENDIX A – RUN RATE<span class="s2">26</span></p>
<p class="p16">B.Net Run Rate<span class="s2">26</span></p>
<p class="p16">C.Net Run Rate(NRR)<span class="s2">26</span></p>
<p class="p16">APPENDIX B - ECB Helmet &amp; Fast Ball Directives for Young Players<span class="s2">26</span></p>

<p class="p19"><br>
<span class="s1">Left Blank Intentionally</span></p>

<ul class="ul1">
  <li class="li21">GENERAL</li>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9"> GENERAL The League playing conditions outline how BTCL conducts matches and can be amended upon member clubs' requests, ensuring transparency and member involvement in updates.:</li>
    <li class="li9">If BTCL-COM proposes an amendment –The amendments to League playing conditions will be circulated to Member Clubs 15 working days before an Annual General Meeting (Proposed Meeting) for comments.</li>
    <li class="li9">Member Clubs must respond with comments ten working days before the Proposed Meeting to ensure their perspectives are considered, making them feel valued in decision-making.</li>
    <li class="li9">The amendment will be agreed upon at the Proposed Meeting.</li>
    <li class="li9">Extraordinary General Meeting—In an extraordinary situation, BTCL-COM can call an emergency meeting (usually within five days) to agree on a change in playing conditions.</li>
    <li class="li9">There will be a fine of £50 for the member clubs if they fail to attend the AGM /SGM</li>
  </ul>
</ul>

<p class="p23">2. FIXTURES</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">The deadline for submitting any changes to fixtures for the following season is 31 December, ensuring the league schedule remains stable and predictable for all teams.</li>
    <li class="li9">Member clubs must advise BTCL-COM of any issues relating to the draft fixtures list within ten working days of receiving it in writing after discussing it with the opponent team. If BTCL-COM considers the reason for a change request appropriate, a change will be made. </li>
    <li class="li9">The last two matches of the season cannot be moved, and the last match for all teams in any division must be played on the same day.</li>
    <li class="li9">Matches not played cannot be rearranged. The BTCL cricket season begins on the first Sunday in May.</li>
    <li class="li9">If a team plays in any other tournament or matches, it must inform the league after agreeing with its opponents before 31 March.</li>
    <li class="li9">Teams from the same clubs can play in the same division, but should be treated as two separate clubs. Therefore, Player transfers are not allowed except for U19 and over-50 home players, for whom transfers are unrestricted. Their fixtures should be played at the beginning as the 1<sup>st</sup> match of each half of the season.</li>
    <li class="li9">Clubs with two or more teams will not be allowed to move players between teams for the season's last two games. They should play where they are originally registered. This rule does not apply to U19 and over-50 players, who are allowed to move freely.</li>
  </ul>
</ul>

<p class="p23">3. CORRESPONDENCE</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">Correspondence relating to the League organisation or any other item should be sent to the General Secretary. Items requiring a response must be sent by letter or email. The League, on its part, will respond to such correspondence within 10 working days after receiving the letter or email, under normal circumstances. All Member Clubs must provide the league with a current and valid postal &amp; email address.</li>
  </ul>
</ul>

<table cellspacing="0" cellpadding="0" class="t1">
  <tbody>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9"><span class="s1">League Correspondence</span> </p>
        <p class="p9">British Tamils Cricket League (BTCL)</p>
        <p class="p9">392 Ewell Road</p>
        <p class="p9">Surbiton </p>
        <p class="p24">Surrey KT6 7BB</p>
        <p class="p9">Fax:020 8150 5667</p>
        <p class="p9">Email address: secretary@btcluk.com</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9"><span class="s1">Our Bankers</span></p>
        <p class="p9">Barclays Bank</p>
        <p class="p9">Account Number: 53469379</p>
        <p class="p9">Sort Code: 20-24-61</p>
        <p class="p9">Account Name: British Tamils Cricket League</p>
        
        <p class="p9">All cheques should be made payable to the British Tamils Cricket League.</p>
      </td>
    </tr>
  </tbody>
</table>
<ul class="ul1">
  <ul class="ul1">
    <li class="li25">Describe the playing conditions in detail and make them self-explanatory as much as possible to avoid the need to call BTCL during the games.</li>
    <li class="li25">No contact is available with BTCL during a game.</li>
    <li class="li25">If there were issues, BTCL would be contacted after the game.</li>
    <li class="li25">Umpires must be consulted as much as possible to resolve any issues.</li>
  </ul>
</ul>
<p class="p23">4. STRUCTURE OF THE LEAGUE </p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">The league consists of the divisions below</li>
  </ul>
</ul>
<ul class="ul1">
  <li class="li9">Premier Division</li>
  <li class="li9">Super Division (Division I)</li>
  <li class="li9">Champions Division (Division II)</li>
  <li class="li9">Legends Division (Division III)</li>
  <li class="li9">Conference Division (Division IV)</li>
  <li class="li9">Community Division (Division V)</li>
  <li class="li9">Challenge Division (Division VI)</li>
  <li class="li9">Classic Division (Division VII)</li>
  <li class="li9">Platinum Division (Division VIII)</li>
  <li class="li9">Development Division (Division IX)</li>
</ul>

<p class="p9">BTCL-COM is authorised to add additional divisions to the league.</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">BTCL-COM may amend the league or division titles to incorporate words or symbols at the request of any of BTCL's sponsors before or during the cricket season. </li>
    <li class="li9">A division shall have a maximum of eight Member Clubs except for the lowest divisions. BTCL-COM is empowered to decide on the number of clubs in the lowest division and submit to member clubs’ approval if the member clubs raise concerns.</li>
    <li class="li9">Each Member Club in the League shall have one home and one away fixture against each team within their division (except the lowest division). </li>
    <li class="li9">The BTCL-COM empowers the Secretary to decide on matters related to promotion/relegation and to request member clubs to prove the eligibility of players playing in that league.The Secretary will refer the refusal to co-operate with the Secretary to the BTCL-COM, who shall take the necessary steps to resolve the matter.</li>
    <li class="li9">BTCL-COM will arrange the fixtures. The BTCL-COM will (if necessary) approve the grounds booked by the member clubs.</li>
    <li class="li9">Any new clubs or teams joining the league would be placed in the bottom division of the league.</li>
    <li class="li9">If a club withdraws from the league during an active season, every match the club played and would have played will be made void. The points for those matches will be set to zero either in advance or retrospectively.</li>
    <li class="li9">A team should play 50% of their scheduled matches; if not, they will be disqualified and must start from the bottom of the league the following year.</li>
    <li class="li9"> Teams from the same clubs that end in the same division can opt to move one of the teams to the next division lower at their discretion. [Refer 2 (f) for their fixture arrangements].</li>
  </ul>
</ul>
<p class="p23"><br>
5. MEMBERSHIP</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">New member clubs are encouraged to join the league before the 31<sup>st</sup> December of the following season (As per AGM Dec 2025 adoption).</li>
  </ul>
</ul>
<p class="p26">BTCL-COM has the right to reject a new club's membership if it is deemed inappropriate for the league's successful running.</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">Existing clubs are urged to pay all outstanding league entry fees by 31<sup>st</sup> January. Failure to do so will result in a penalty of 20 points per match.</li>
    <li class="li12">BTCL Treasurer will formally notify all clubs of any outstanding balances by 31 August (of the season). All debts must be cleared by 31 October.<br>
Any club that fails to clear its outstanding debt by 31 October will forfeit its current league division position and be required to restart in the bottom division the following season (to be adopted at the 2026 AGM).</li>
    <li class="li9">Annual Membership fees will be determined by BTCL-COM and will be announced to all Members of BTCL. To encourage new clubs to join the league, BTCL-COM was empowered to lower new membership fees.</li>
    <li class="li9">Member clubs must pay any outstanding payments to grounds authorities by 31<sup>st</sup> December. Failing to do so will result in disciplinary proceedings. This will result in the club being relegated to a lower division or expelled from league membership.</li>
    <li class="li9">Member Clubs can merge, subject to BTCL-COM approval, with similar community clubs to field a stronger team to promote community cricket. Member clubs must confirm this in writing before the Special General Meeting, usually held on the last Sunday in March. BTCL-COM will conduct a review to determine whether the merger is in the best interests of BTCL (Community Cricket League).</li>
  </ul>
</ul>

<p class="p23">6. LEAGUE ENTRY FORM &amp; FEE</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">League entry fee will be £400 from the 2026 season.Subsequent teams of the same club will be charged £200 each (AGM Dec 2025 adoption).</li>
    <li class="li9">If the teams fail to pay the fee by 31st January, there will be a 5-point deduction for the season, and a £100 late payment fee will be due to the league.</li>
    <li class="li9">If a team pays 50% of the fee as a deposit (which is non-refundable), there will be no penalty points, but there will still be a £50 penalty.</li>
    <li class="li9">If the team has not paid by 31st March, the penalty will be increased to a 10-point deduction and a £200 late payment fee.</li>
    <li class="li9">If the team has not paid by the start of the season, they would be deemed to have withdrawn from the league. The next club in line from the following division will be promoted. Note: The season start date is defined as the end of the 1<sup>st</sup> player registration window.</li>
    <li class="li9">All new teams must pay the full fee at the time of the application.</li>
  </ul>
</ul>

<p class="p23">7. FINES AND POINTS REDUCTION</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li27">Please refer to the table below for penalties and fines. BTCL-COM is empowered to take action against any infringement of the league's playing conditions.</li>
    <li class="li27">Member Clubs’ attention is also drawn to the following. The League considers that each Member Club must provide the League each year with:</li>
    <li class="li27">All challenge trophies must be returned to the League by 31st August. If the challenge trophy is lost, the teams must pay £250.</li>
    <li class="li27">Failure to provide any of these items by the date shown will result in a fine of £50. Any fine not paid within 10 days shall be doubled. If it remains unpaid for a further 10 days, it will be trebled, and so on until final settlement.</li>
    <li class="li27">Unsatisfactory ground quality and facilities lead to a £50 fine with a 5-point reduction. </li>
    <li class="li27">The clubs must take responsibility for booking the grounds. The match will be regarded as forfeited if the grounds are not booked and the scheduled match is not played as per the fixtures.</li>
  </ul>
</ul>
<table cellspacing="0" cellpadding="0" class="t1">
  <tbody>
    <tr>
      <td valign="middle" class="td1">
        <p class="p28">Offence</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p28">Penalty/Fine</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Non-payment of league fee by 31<sup>st</sup> January</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5 points and £100</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Non-payment of league fee by 31<sup>st</sup> March</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">10 points and £200</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Loss of the challenge trophy</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">£250</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Unsure player name in Play Cricket</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">2 points per UNSURE player name</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Ineligible player</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Loss of game. 20 points penalty &amp; no bonus points</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Unsatisfactory ground facilities</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5 points and £50</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Non-registered player</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Loss of game, 40 points, and 20 points for the following season</p>
      </td>
    </tr>
    
    
    
    
    
    
    
    
    
    
  </tbody>
</table>

<p class="p23">8. PLAYER REGISTRATION</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">A team can register a maximum of 30 players and at least 13 by the 30<sup>th</sup> of April.</li>
    <ul class="ul1">
      <li class="li29">All players (including home and overseas) should be allowed to play without restrictions in the 2025 season (AGM 2024 adoption).</li>
    </ul>
    <li class="li9">Member clubs are responsible for registering only eligible players in their teams. Breach of player registration rules is subject to disciplinary action by the BTCL disciplinary committee. BTCL accepts the player’s registration application in good faith. All clubs must update the registered player's photo to a current UK passport-style photo (white background; no caps/sunglasses allowed).</li>
    <ul class="ul1">
      <li class="li9">Player Documentation Responsibility Member clubs are solely responsible for verifying the authenticity of all player documents. Clubs must conduct their own internal checks with the relevant authorities to ensure that all submitted documents are genuine. Any team found guilty of submitting forged or fake documents will be relegated to the next division (as per AGM Dec 2025 adoption).</li>
    </ul>
    <li class="li9">Player names must be identical in both the BTCL system and in Play Cricket (per the AGM Dec 2025 adoption)</li>
    <li class="li9">Only 15 players chosen by the team will be listed for awards.</li>
    <li class="li9">A team can register up to TWO “non-home” players; however, only one “non-home” player can play in a match.A home player is defined as a Sri Lankan Tamil or of Sri Lankan Tamil heritage (having one parent who is a Sri Lankan Tamil) who has the right to remain in the UK.A player can play under the category of “home player” by providing proof in the form of his passport or parent(s)’ passports (to show that he is of Sri Lankan Tamil by birth or of Sri Lankan Tamil heritage).<span class="s3">If passport evidence is not forthcoming, other evidence may be considered at BTCL-COM's discretion.</span> (As per the AGM Dec 2025 adoption).</li>
    <li class="li9">Any club fielding two or more teams only allows a maximum of two interchangeable home players. Under-19 home players or over-50 Players (SGM 2023 adoption) can be moved within their club teams without restrictions; however, the teams must inform League Welfare Officers about their participation in the open-age games. (This does not apply to “non-home” Under-19 players, which means they fall within the maximum of two interchangeable players.)</li>
    <ul class="ul1">
      <li class="li9">U19 Age eligibility will be determined using the league start date (1st May) as the cutoff for age and date of birth calculations, as per AGM Dec 2026.</li>
    </ul>
    <li class="li9">If an ineligible player took part in a match and his appearance on the field is proven, the following penalties are applicable.</li>
    <ul class="ul1">
      <li class="li9">The team that violates the rule is deemed to have lost the game and will receive a 20-point penalty for the match.</li>
      <li class="li9">The opposition will be awarded the game (20 points).</li>
    </ul>
    <li class="li9">Any UK-born “Tamil” (defined as a player of any Tamil heritage) player who is under 21 at the start of the season (defined as the date of the first match of the season) will be treated as a home player.</li>
    <li class="li9">A non-Sri Lankan Tamil player with the right to stay in the UK should register as an overseas player for the first two years of his time in the BTCL. In his third year, he will become a home player (the BTCL-COM may request evidence). Please note that the player needs to serve this only for two years with any member club.</li>
    <ul class="ul1">
      <li class="li9">To be classified as a home player in their third year, a Non–Sri Lankan Tamil player is required to have played a minimum of one match per season (as per AGM Dec 2025 adoption).</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li9"><span class="s1">Non-home Player Registration</span></li>
    <ul class="ul1">
      <li class="li9">Teams can register up to 2 overseas players by the 30<sup>th</sup> of April. If one or both of the two registered non-home players have not played in the season, they can be replaced with another non-home player(s) between 15 May and 15 June.</li>
    </ul>
  </ul>
</ul>
<p class="p9">Non-Home players registered in the 2nd registration window can play from the 8th match of the season onward (per the adoption at the AGM in Dec 2025).</p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">The registration of non-home players will be scrutinised according to BTCL policy. If BTCL-COM detects any irregularity in the registration process, it has the right to reject the registration without providing details.</li>
    </ul>
    <li class="li9">Any new “home” player with the right to UK residency can register and play at any time during the season with seven days’ notice to the registration team (the incoming player should not already be registered with any of the BTCL Clubs).Registration should be done in the BTCL system and the Play Cricket system (December 2024 AGM adoption)</li>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li9"><span class="s1">Player Transfer between clubs</span></li>
  </ul>
</ul>
<p class="p9">Player transfer between clubs.If a player wishes to transfer from one club to another, the following steps must be taken.</p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">The player in question needs to inform in writing by email the current club, the new club and to BTCL (info@btcluk.com) with the following text, “I [Player’s full name] with BTCL player id [insert BTCL player id] wish to transfer from [insert current team name/club name] to [insert new team name/club name]. The contact email addresses for the clubs must be obtained from the BTCL website, and team and club names should match those listed there.Any anomalies or omissions will lead to the request being rejected.</li>
      <li class="li9">If the transfer is requested in mid-season, the player must confirm that he has not played any games in the current season for the current club by inserting the text “I also confirm that I have not played any matches for the [insert current team/club name]”.Failure to confirm this will lead to the transfer request being rejected.</li>
      <li class="li9">In addition, BTCL expects the new club to verify that the player has not played any games in the current season. If a player has played any game(s) in the current season, he cannot be transferred to the new club.The new club must also verify the eligibility criteria of the player being transferred by verifying the necessary documents.</li>
      <li class="li9">BTCL will action the transfer and inform in writing to the current club, the new club, and the player by return email.</li>
      <li class="li9">The new club must then follow the transfer process within Play Cricket to transfer the player to them.BTCL does not take the responsibility for changes in Play Cricket and expects the player record to be correct before the commencement of a match in which the player is due to take part.</li>
      <li class="li9">If any breaches are found in the above process, BTCL reserves the right to take action against the offending team(s)//club (s) or the player.</li>
      <li class="li9">To minimise the workload on BTCL, a player is allowed a maximum of two transfers in a calendar year.</li>
      <li class="li9">U19 players can be transferred between (even if they have played for the current club) midseason (as per AGM2 Dec 2025 adoption).</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li9"><span class="s1">Player transfer within a club (i.e., between the teams of a club)</span></li>
    <ul class="ul1">
      <li class="li9">A player can be transferred from one team to another within the club, provided that he has not played any games for the current team.</li>
      <li class="li9">If a player registered for the ‘A’ team of the club, but only played for the ‘B’ team (or vice versa) of the club during the 1st half of the season, the club can transfer the player from the ‘A’ team to the ‘B’ team (or vice versa) at any point after 1st half of the season (this also applies vice versa i.e., for a player.</li>
      <li class="li9">The clubs can do this action by using their team login on the BTCL website.</li>
      <li class="li9">If any breaches are found in the above process, BTCL reserves the right to take action against the offending team(s)/club(s)</li>
      <li class="li9">Player removal allowed if the player did not play a single match for the season.</li>
    </ul>
    <li class="li9">During registration, the BTCL-COM has the right to ask for proof to establish the player’s origin and immigration status.</li>
    <li class="li9">Only acceptable proofs of the players are as follows:</li>
    <ul class="ul1">
      <li class="li9">Original passports (not a copy) OR</li>
      <li class="li9">UK driving license (with photo) </li>
    </ul>
    <li class="li9"> If the above is not attainable, BTCL requires a United Kingdom Border Control Photo ID. After submitting the proofs, BTCL-COM may require an interview with the player to establish the player's status.</li>
    <li class="li9"> Captains/Managers shall be responsible for uploading all newly registered player photographs onto the BTCL official website. (File size less than 1MB, 300 X 300 pixels; see below for the quality)</li>
    <li class="li12"> The following details must be entered while registering a player, <br>
First name, Surname, Club Name, Date of Birth, Player Stats,<br>
Home/Non-Home Player, Age Group: Pro/U19/U15<br>
Short names and nicknames are only accepted when accompanied by a full name. If the BTCL-COM determines that the provided details are incorrect, the registration will be declined.</li>
    <li class="li9"> It is the responsibility of the member clubs to identify their player’s eligibility to play in the community cricket league. BTCL will act in good faith by accepting the player’s registration upon first submission. If it is later proved that the clubs played with ineligible players, this will be subject to disciplinary action. If an ineligible player took part in a match and his appearance in the field is proven, the following penalties are applicable. If the team violates the playing conditions, 40 points will be deducted; if the team that violated loses, 20 points and any bonus points earned in that match will be deducted. If a player is reported to have been registered incorrectly, the registration team will fully investigate the report. If the reported ineligibility is proven, all matches the ineligible player has played in this season will be penalised. 20 points per game he played, and any bonus points the team earned in those matches will be deducted. If a player is found guilty of improperly registering at ANY POINT in the season, all the matches he played will be penalised (if the player played on the winning side, -40; on the losing side, -20). This condition will apply to all the existing and new registered players. All Clubs, please make sure all your registered players are correctly registered in accordance with the player registration rules.</li>
    <li class="li9"> The member club’s manager will be given a choice to select the appropriate name that should be displayed on the public website.</li>
    <ul class="ul1">
      <li class="li9">Photo Size and Quality: UK Passport size photos with clear background (No trees behind, No caps, No sunglasses, and No hats). Registration with poor-quality photos will be rejected. </li>
      <li class="li9">If a Club would like to go into an agreement with a sponsored home category player, then BTCL will accept that agreement for a nominal fee of £20. That player will not be allowed to play for any other BTCL clubs during the term of the agreement.</li>
      <li class="li9">Teams with players under the age of 18 should notify the League Welfare Officer (LWO). Captains of those teams require cricket-specific DBS checks. For more details, check county websites or contact LWO.</li>
    </ul>
    <li class="li9">Non-registered players playing in matches:</li>
    <ul class="ul1">
      <li class="li9">There will be a 40-point penalty in the current year and a further 20-point penalty for the following year for the offending team.</li>
      <li class="li9">No losing bonus points will be awarded if the offending team loses.</li>
      <li class="li9">The opposition team (to the offending team) will be awarded a win.</li>
      <li class="li9">The statistics of the offending team players will stand.</li>
      <li class="li9">The matter must be reported to the BTCL committee within 72 hours of the match day.</li>
    </ul>
  </ul>
</ul>

<p class="p23">9. MATCHDAY</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">General</li>
    <li class="li20">If the pitch is deemed unsafe to play, the umpire reserves the right to cancel the match at any point of the game (whether before or during). It is the home team’s responsibility to ensure the pitch is fit for play. The match will be regarded as a forfeiture, and the away team will receive the winning points; the home team will receive no points. If this occurs for the second time, the home team will be deducted 20 points.</li>
    <li class="li20">The home team’s responsibility is to make sure all appropriate markings (boundary, creases, 30 yards, etc) are clearly visible for the game to begin. Otherwise, the match will be considered a forfeiture; the away team will receive the points, and the home team will receive none. If this occurs for the second time, the home team will be deducted 20 points.</li>
    <li class="li20">Each captain shall provide a list of the names of 11 players and (optionally, the nominated 12th man) in Play-Cricket to the opposing team captain before the toss. No players (including the nominated 12th man) may be changed after the toss without the consent of the opposing team captain.</li>
    <li class="li30"><span class="s4">If a team cannot present at least 7 players dressed and ready to play after the scheduled start time, they will lose one over every 4 minutes of the delayed start. If it continues for 60 minutes from the scheduled start time, the match will be regarded as a walkover to the opposition. </span>All walkover matches must be reported to BTCL by Wednesday midnight; otherwise, a -20 points penalty will be carried forward to next season in addition to the -20-point penalty applied for the current season (in case of the last two games, a -40 points penalty per game for the current season and next season).</li>
    <li class="li20">Teams that fail to update their scorecards on Play-Cricket will be penalised 5 points, as delays create significant issues for the Registration Team in resolving complaints.All scorecards must be fully and correctly completed on Play-Cricket. Failure to comply with the following requirements will result in a 5-point penalty for the club. No unnamed or “unsure” player entries are permitted. Only registered players on Play-Cricket may be included. Manual entries are not allowed. All catchers’ names must be entered. If a catcher’s name is left blank, it cannot be amended after Monday midnight. Player names must exactly match those registered on the BTCL Website, and Play-Cricket results, including a complete scorecard, must be submitted in Play-Cricket by midnight on the Monday following the game.Scorecard will be locked at 00:01 on Tuesday following the game.Any issues with the scorecard must be reported to the results secretary by Wednesday midnight.After that, no scorecard information can be amended. (Per the AGM Dec 2025 adoption).</li>
    <li class="li20">The umpires will update the fair play assessment.This may result in a deduction of points.</li>
    <li class="li20">Unless otherwise specified, infringement of any League playing conditions renders the Member Club liable to a minimum of 2 points reduction.</li>
    <li class="li20">Teams with players under the age of 19 should notify the League Welfare Officer (LWO). Captains of those teams require cricket-specific DBS checks. For more details, check county websites or contact LWO.</li>
    <li class="li20">Interrupted matches should use the Duckworth-Lewis Stern calculator in Play-Cricket.Please follow the link below</li>
    <li class="li20">https://play-cricket.ecb.co.uk/hc/en-us/articles/360000280645-In-Game-Duckworth-Lewis-Calculator-PCS-</li>
    <li class="li20">Teams from the same club that play in the same division will not be allowed two interchangeable players, except U19 players and over-50 players, who can be interchanged without restrictions. Their fixture should be played at the beginning of the season. It should be the first match of the season, with the second fixture being the first game after the season midpoint.</li>
    <li class="li20">A runner for the batsman is not permitted.</li>
    <li class="li20">Umpire fee of £80 (single umpire) &amp; £60/umpire (two umpires), shared equally by teams [Agreed in AGM 2024]</li>
    <li class="li20">The umpire’s word is final in all instances of a match.</li>
    <li class="li9">Captains/Managers are encouraged to check the BTCL website and take a printout of players and identify their team for the match day. A player not registered with BTCL shall not play in the game. (See section 7 for player registration). </li>
    <li class="li12">A runner for the batsman is not permitted.</li>
    <li class="li31">Duration of Match</li>
    <ul class="ul1">
      <li class="li9">All divisions shall play a match of 80 overs maximum and 40 overs minimum. </li>
      <li class="li9">Each team must play a minimum of 20 overs. Otherwise, the match shall be deemed abandoned (10 points for each team).</li>
      <li class="li9">The side batting first will take up a maximum of half the allotted overs.</li>
      <li class="li9">A tea interval, not exceeding 30 minutes, will normally be taken between innings. It can be taken earlier or later, if circumstances make either a sensible option, but only at the umpires' discretion.</li>
      <li class="li9">The fielding Captain shall agree on drinks intervals with the Umpires before the start of each innings. A maximum of 5 minutes will be allowed for each drink break. Players may take drinks at the boundary edge at the end of the over or fall of wicket or suspension in play, but must be ready when the bowler is ready to deliver the ball. This will be dealt with under Law 41.9 (Time wasting by the fielding side) and Law 41.10 (Batman wasting time). Time for agreed drink intervals shall be excluded when calculating any remaining time.</li>
      <li class="li9">The maximum number of overs bowled by any bowler [England and Wales Cricket Board (ECB) rules apply for players under 19] may not exceed one-fifth of the total to be bowled by his side, assuming the innings runs its full length. If a bowler breaks down and is unable to complete an over, another bowler shall bowl the remaining balls of that over. Such a part of an over shall count as a full over to both bowlers, but only one in the total number bowled in the innings.</li>
    </ul>
    <li class="li9">Start Times</li>
    <ul class="ul1">
      <li class="li9">All matches start at 13:00 hrs.</li>
      <li class="li9">The umpire must be present at the game by 12.30 pm.</li>
      <li class="li9">Coin toss at 12:45 pm.</li>
      <li class="li9">A team unable to present a minimum of 7 players dressed and ready to play for the coin toss will automatically lose the toss.</li>
      <li class="li9">Punctuality is essential. A Member Club responsible for a late start or a delay in restarting after tea will incur the minimum point reduction. This is also a ‘totting up’ offence. </li>
      <li class="li9">Educate the umpires to work with captains to finish the overs in the allotted time.</li>
      <li class="li9">If a team is unable to present a minimum of 7 players dressed and ready to play after the scheduled start time, they will lose one over for every 4 minutes of the delayed start. And if it continues for 60 minutes from the scheduled start, then the match will be regarded as a walkover. </li>
      <li class="li9">If play cannot begin within THREE HOURS of the scheduled start time, then the match will be regarded as abandoned (5 points for each team).</li>
      <li class="li9">If play can commence before 4 pm (i.e., within 3 hours of the start time), the number of overs will be reduced as per playing conditions:</li>
      <ul class="ul1">
        <li class="li9">A 20-20 game must be played for the game to be official.</li>
        <li class="li9">The delay must be due to unavoidable circumstances, such as weather interruption or the ground being handed over late.</li>
      </ul>
    </ul>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <li class="li32">Walkover</li>
    <ul class="ul1">
      <li class="li9">If a team fails to present a minimum of 7 players after 60 minutes from the start of the scheduled time, then the opponent team is awarded the game, and the match is considered a walkover. The winning team is awarded 20 points, and the opposition will be deducted 20 points as a penalty. If a walkover is granted due to unavoidable or exceptional circumstances, such as accidents, evidence should be submitted within 48 hours, e.g., video, photos, or documents supporting the incident.</li>
      <ul class="ul1">
        <li class="li9">BTCL considers walkovers at the end of the season very seriously and will implement tighter control to avoid such events. </li>
      </ul>
      <li class="li9">If a walkover occurs during the last two matches of the season, the points reduction accumulated in those matches will be carried over to the next season. This will be -40 penalty points per match for the current season, with the same penalty points carried forward to the next season (SGM 2023 adoption).</li>
      <li class="li9">If a team can't play a match, it should inform the BTCL secretary/ umpire coordinator/ scorecard secretary and opponent team manager by at least Wednesday 6:00 pm before the said date. If the team fails to do so, it is liable for the full umpire payment (per the AGM 2024 adoption).</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Late Arrival of a Player</li>
    <ul class="ul1">
      <li class="li9">A player who arrives 60 minutes after the scheduled start of the game can only take part as a substitute.</li>
      <li class="li9">When a player arrives after the match has started but within the 60-minute cut-off time, the following will apply:</li>
    </ul>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <ul class="ul1">
        <li class="li9">Fielding Side: The Player will not be allowed to bowl until he has been on the field of play for an equivalent number of completed overs that had been bowled prior to his appearing on the field of play.</li>
        <li class="li9">Batting Side: The Player will not be allowed to bat until he has been present at the ground for an equivalent number of completed overs that had been bowled before his arrival (except on the fall of the 5th wicket in the event of batting side fielding only 7 players). The onus is on the captain of the batting side to show the umpires that the player has arrived.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">If the late arrival player is proven unregistered, then report the matter to the BTCL committee within 72 hours of the match day.</li>
      <ul class="ul1">
        <li class="li9">Condition 1: if the winning team disqualifies, the losing teams will be considered as winners (penalty points will apply to the offending team)</li>
        <li class="li9">Condition 2: If the losing team is disqualified, penalty points will apply</li>
      </ul>
    </ul>
  </ul>
</ul>

<p class="p34">9.7 Less than 11 Players</p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">A minimum of 7 players constitutes a team.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Over Rates</li>
    <ul class="ul1">
      <li class="li9">All Member Clubs must bowl their allotted overs within 3 hours. Declarations are not permitted (AGM Dec 2025 adoption).</li>
    </ul>
  </ul>
</ul>

<p class="p9"><span class="s1">Over-rate penalties</span></p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">All sides are expected to bowl the first ball of the 40<sup>th</sup> over within 3 hours of start time. If they fail to do so, the full quota of overs will be completed, but the batting side will be credited with six runs for every whole over that has not been bowled within the allotted 3 hours. This will apply to both innings of the match. If the side batting second is credited with runs in this way and this consequently takes their score past the side batting first, then the match shall be deemed to be won by the side batting second.Any remaining overs need not be bowled.All penalties in this regard will be imposed immediately.</li>
      <li class="li9">If the innings is terminated before the scheduled or rescheduled cut-off time.No over-rate penalty shall apply. If the innings is suspended, the over-rate penalty will apply based on the re-scheduled cessation time for that innings.</li>
      <li class="li9">If the play was interrupted due to weather, the umpires shall inform the captains (when taking the field for the first time and on every subsequent occasion after the interruption) of the scheduled time for that innings. The Umpires shall make allowances for any occurrence beyond the control of the fielding side that slows down the overall over rate. Batsmen will normally be expected to cross on the field of play at the fall of a wicket. The Umpire at the bowler’s end will inform the fielding Captain, the batsman, and his fellow Umpire of any time allowances as and when they arise. (This matter will not be subject to retrospective negotiation.) In addition, and for over-rate penalties only, in all reduced-overs matches, the fielding team will be given a one-over leeway.</li>
      <li class="li9">Over-rate, penalties apply only to innings of 20 overs or more duration.</li>
      <li class="li9">The penalties in this paragraph are the only penalties for a slow over-rate.</li>
    </ul>
  </ul>
</ul>

<p class="p9"><span class="s1">Responsibility of Captains</span></p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">The captain is responsible for all aspects of the conduct of his side, including over-rates. If the Umpires feel that their advice in this matter is being wilfully ignored, the captain of the fielding team may find his name included in the Umpires’ report for possible disciplinary action.</li>
    </ul>
  </ul>
</ul>

<p class="p9"><span class="s1">On-field sanctions under Law 42</span></p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li12">Should the Umpires invoke the procedure for on-field sanctions under Law 42, the time for the closure of the innings shall be extended by an equivalent period to the time taken for those procedures to be invoked. <br>
</li>
      <li class="li9">In the event of them failing to do so, the full quota of overs will be completed, and the batting side will be credited with 6 runs for every whole over that has not been bowled. This will apply to both innings of the match. If the side batting second is credited with runs in this way and consequently takes their score past that of the side batting first, then the match shall be deemed to be won by the side batting second. All penalties in this regard will be imposed on the ball immediately after it first becomes dead after the scheduled or rescheduled cessation time for the innings.</li>
      <li class="li9">Over-rate penalties apply only to innings of 20 overs or more duration.</li>
      <li class="li9">Umpires will be the judges of any extenuating circumstances.</li>
      <li class="li9">At the 3rd offense (of a team), the matter will be referred to the disciplinary committee.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Introducing Power Play</li>
    <ul class="ul1">
      <li class="li9">The power play has been introduced for all divisions. Field restrictions are:</li>
      <ul class="ul1">
        <li class="li9">Power play 1 (Over’s 1 to 8): No more than 2 fielders shall be permitted outside the 30-yard circle.</li>
        <li class="li9">Power play 2 (Over’s 9 to 32): No more than 4 fielders shall be permitted outside the 30-yard circle.</li>
        <li class="li9">Power play 3 (Overs 33 to 40): No more than 5 fielders shall be permitted outside the 30-yard circle.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Pitch - "Area to be protected”.</li>
    <ul class="ul1">
      <li class="li9">The area of the pitch, which must be protected from the bowler, will be regarded by the umpires as the rectangle formed by two imaginary lines 5ft in front of and parallel to each popping crease and two more imaginary, parallel lines drawn one foot either side of the centre of the middle stumps.</li>
      <li class="li9">Bowler running onto the protected area after delivering the ball, batsman running between wickets using the protected area and fielders entering the protected area are contravened by the law. Two cautions will be issued to the involved parties, and on the third occasion, the bowler will be asked to stop bowling; for the batting side, this will be regarded as <span class="s1">no runs</span>. The officiating umpires will award a penalty of 5 runs. All parties involved will be reported to the league.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Matches Affected by Adverse Weather/Ground Conditions</li>
    <ul class="ul1">
      <li class="li9">Matches cannot be cancelled due to adverse weather or ground conditions within THREE HOURS before the scheduled start time unless ground authorities send a written cancellation note.</li>
      <ul class="ul1">
        <li class="li9">No blanket cancellations by BTCL-COM are permitted (AGM Dec 2025 adoption).</li>
      </ul>
      <li class="li9">If the away team chooses this option (a) and there is no play, they must pay both umpires' expenses and at least half the cost of the tea.</li>
      <li class="li9">Away team can insist on all parties being available to start at the scheduled time if they feel cancellation is unreasonable. </li>
      <li class="li9">If play cannot begin within THREE HOURS of the scheduled start time, then the match will be regarded as abandoned</li>
      <li class="li9">In these circumstances, the umpires are the sole judges as to whether or not conditions are fit for play.</li>
      <li class="li9">If the groundsman or grounds authority cancels the grounds reasoning, safety, and pitch condition, then BTCL requires an email confirming the cancellation from the groundsman or authority who manages the ground. </li>
      <li class="li9">If adverse weather delays the start of a match or during the innings for more than 15 minutes, umpires will deduct overs as follows:</li>
      <ul class="ul1">
        <li class="li9">Up to 21 minutes - 3 overs each side.</li>
        <li class="li9">28 minutes - 4 overs each side.</li>
        <li class="li9">35 minutes - 5 overs each side and so on (i.e., further deductions of one over per side for every seven minutes or part thereof) down to a minimum of 20 overs per side. This applies to all divisions. However, see point (d) above.</li>
      </ul>
      <li class="li9">Weather-affected match results shall be determined based on the Duckworth-Lewis method (as directed by BTCL – See point (j) below), provided that the teams played a minimum of 20 overs.</li>
      <li class="li9">If bad light stops play under any circumstances, the DL method applies to adjudicate the winner, provided that the teams played a minimum of overs.</li>
      <li class="li9">Interrupted matches: Interrupted matches should use the Duckworth-Lewis Stern calculator in Play-Cricket.Please follow the link below <span class="s1">https://play-cricket.ecb.co.uk/hc/en-us/articles/360000280645-In-Game-Duckworth-Lewis-Calculator-PCS-</span></li>
    </ul>
  </ul>
</ul>

<p class="p23">9.12 Facilities</p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li23">Covers</li>
    </ul>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <ul class="ul1">
        <li class="li9">Member Clubs must use covers to completely or partially protect the pitch during inclement weather, to allow play to start and/or resume. As per Law 10.2.1, the whole pitch and a minimum of 4 ft. /1.22 m beyond it at each end shall be covered.</li>
        <li class="li9">Member Clubs must use covers if adverse weather causes a delayed start to a match or if there is an immediate interruption of play. Umpires must report any Member Club failing to do so.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li23">Sight Screens</li>
      <ul class="ul1">
        <li class="li9">Unless otherwise dispensed from the league, all Member Clubs must have a sight screen at each end. Where any screen is on the field of play, it must be roped off so that it is completely beyond the boundary.</li>
        <li class="li9">The batting side captain must delegate people to move sight screens as required during that innings if requested to do so by the fielding side captain.</li>
        <li class="li9">Sight screens are compulsory for the Premier Division and Division 1.</li>
      </ul>
      <li class="li23"> Local Conditions</li>
      <ul class="ul1">
        <li class="li9">Member Clubs must post clear notices in the away team and umpires’ changing rooms, detailing any local conditions under which matches are to be played. The captain of the home team is responsible for explaining these in the pre-toss discussion with the umpires and the away team captain.</li>
        <li class="li9">Members of the batting side must search for any lost balls during play.</li>
        <li class="li9">Power installed and, if possible, adequate toilet facilities. </li>
        <li class="li9">The home club is responsible for ensuring that distractions are avoided from both players and spectators.</li>
      </ul>
      <li class="li23">Pitches</li>
      <ul class="ul1">
        <li class="li9">Must have strong grass roots, be free from weeds, moss, stones or other foreign bodies, flat and even and have evidence of rolling. In addition, the pitch must have been prepared by either a professional groundsman or an appointed representative with the necessary skills and equipment.</li>
      </ul>
    </ul>
  </ul>
</ul>
<p class="p38">Astro pitches are not permitted (As per AGM Dec 2025 adoption).</p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <ul class="ul1">
        <li class="li9">It is the home team’s responsibility to make sure pitch markings are clearly visible for the game to begin.The home team must take every possible step to ensure the pitch is in a playable condition.Failure to do so will result in the match being awarded to the away team, and the home team will receive no points. If this occurs for a second time, the home team will be deducted 20 points.The home team should readily provide evidence of pitch bookings or any form of proof to the BTCL-COM in the event of any breach.The umpires are the sole judges of whether the pitch is playable or not.Both teams must abide by the umpire’s decision.Play can continue under protest, if needed, and the BTCL-COM must be notified within 48 hours.</li>
        <li class="li9">The umpire could cancel the match considering the safety and pitch conditions. The teams must play a minimum of 10 overs before making any decision based on the pitch condition. If the umpire deems an unsafe pitch before 10 overs, he can stop the play. </li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li23"> Outfield</li>
      <ul class="ul1">
        <li class="li9">Must be free from stones, glass, or other foreign bodies, free from bare patches and evenly cut without excessive grass cuttings.</li>
        <li class="li9">There must also be a clearly defined boundary—minimum 65 yards and maximum 90 yards measured from the centre of the pitch.</li>
        <li class="li9">For power play divisions, a 30-yard circle apply (see 8.12 section C).</li>
        <li class="li9">If BTCL permits a ground to have less than 65 yards, then the 30-yard circle may be reduced proportionally with the agreement of two captains and umpires before the start of the match.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li23">Scoreboard</li>
      <ul class="ul1">
        <li class="li9">Must be covered and protected from the weather with easily accessible numbers (electronic or manual).</li>
        <li class="li9">The score box must be easily seen from the field of play, and adequate visibility must be available to the scorers.</li>
        <li class="li9">The score box must be kept in a clean and tidy condition and be safe in all aspects.</li>
        <li class="li9">Drinks are to be provided to scorers during the drinks interval in each innings.</li>
        <li class="li9">A scorer from both teams must be available at all matches and given reasonable training to carry out their tasks.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Fair Play Assessment</li>
    <ul class="ul1">
      <li class="li9">To encourage and reward fair play, BTCL has introduced a fair play assessment system; umpires will be evaluating each team on a match-by-match basis on the following criteria:</li>
      <ul class="ul1">
        <li class="li9">Punctuality</li>
        <li class="li9">Timekeeping</li>
        <li class="li9">Player’s behaviour</li>
        <li class="li9">Facilities</li>
      </ul>
      <li class="li9">Points deducted on a match-by-match basis, based on a fair play card uploaded by the umpire officiating the match.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Match Balls</li>
    <ul class="ul1">
      <li class="li9">All the league teams must use BTCL balls.</li>
      <li class="li9">All Division Member Clubs must use the cricket balls provided by the British Tamils Cricket League.</li>
      <li class="li9">Ball cost will be included in the membership.</li>
      <li class="li9">If a ball is lost within the first 8 overs, the bowling team must continue the match using a brand-new ball. The home team is responsible for providing the replacement ball <span class="s2">(As per AGM Dec 2025).</span></li>
      <li class="li40"> Both teams must hand over their match balls to the umpire at the time of the toss (As per AGM Dec 2025).</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li41">Fielding Restrictions</li>
    <ul class="ul1">
      <li class="li9">At the instant of delivery, there may not be more than 5 fielders on the leg side.</li>
      <li class="li9">Two semi-circles shall be drawn on the field of play by the home team. The semi-circles shall have as their centre the middle stump at either end of the pitch. The radius of each of the semi-circles shall be 30 yards (see 9.9 (e) outfield criteria). The ends of each semicircle shall be joined to the other by a straight line drawn on the field on the same side of the pitch. The fielding restriction area should be marked with 'dots' at five-yard intervals, each 'dot' covered by a white plastic or rubber disc (not metal), measuring seven inches in diameter.</li>
      <li class="li9">The following fielding restrictions shall apply for all Divisions:</li>
    </ul>
  </ul>
</ul>

<p class="p43"><span class="s1">Fielding restrictions</span></p>
<table cellspacing="0" cellpadding="0" class="t1">
  <tbody>
    <tr>
      <td valign="middle" class="td1">
        
        
        
        <p class="p9">No of players</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Power play 1 <br>
(1 to 8 overs)</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Power Play 2 <br>
(9 to 32 overs)</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p12">Power play 3 <br>
(33 to 40 overs)</p>
      </td>
    </tr>
    <tr>
      
      <td valign="middle" class="td1">
        <p class="p9">Inside30 yards</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Outside 30 yards</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Inside 30 yards</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Outside 30 yards</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Inside 30 yards</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Outside 30 yards</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">11</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">9</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">2</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">10</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">9</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">1</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">3</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">9</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">9</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">2</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">3</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">1</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">2</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">0</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">1</p>
      </td>
    </tr>
  </tbody>
</table>

<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li47">Power Play has been introduced for all divisions. Refer to condition 9.7 field restrictions.</li>
      <li class="li47">In circumstances when the number of overs of the batting team is reduced, the number of Power Play overs shall be reduced in accordance with the table below. For the sake of clarity, it should be noted that the table shall apply to both the 1st and 2nd innings of the match where the number of overs of both teams is reduced. The number of overs under the restrictions shall be as set out in the following table. If, on resumption after a delay, the number of overs has been exceeded, this shall take effect immediately.</li>
    </ul>
  </ul>
</ul>
<table cellspacing="0" cellpadding="0" class="t1">
  <tbody>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">Innings Duration</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Power Play 1</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Power Play 2</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">Power Play 3</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">40</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">24</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">39</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">23</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">38</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">23</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">37</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">8</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">22</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">36</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">22</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">35</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">21</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">34</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">20</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">33</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">20</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">32</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">7</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">19</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">31</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">19</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">30</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">18</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">29</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">17</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">28</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">17</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">27</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">6</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">16</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">26</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">16</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">25</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">15</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">24</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">14</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">23</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">14</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">22</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">5</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">13</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">21</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">13</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
    </tr>
    <tr>
      <td valign="middle" class="td1">
        <p class="p9">20</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">12</p>
      </td>
      <td valign="middle" class="td1">
        <p class="p9">4</p>
      </td>
    </tr>
  </tbody>
</table>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Ground &amp; Facilities Reporting and Inspection</li>
    <ul class="ul1">
      <li class="li9">Team captains, scorers, or a club official deputised for that purpose, will be responsible for advising the League through a questionnaire provided, whether the required standards are met on grounds visited under match day conditions.</li>
      <li class="li9">Member Clubs that fail to meet acceptable standards, when all such reports are considered, will be required to improve their ground to the required standard, within a time specified by the BTCL-COM.</li>
      <li class="li9">The Member Club or Member Clubs concerned will also be subject to a minimum of two spot checks by at least two members of BTCL-COM to ensure the improvements have been made.</li>
      <li class="li9">Teams are required to book grounds up to a maximum of 15 miles outside the M25 area (measured in a straight line) – AGM 2024 adoption.</li>
      <li class="li9">Recreation ground rules – Applicable to those teams who play on council grounds. Normally, the council prepares the pitch on a Wednesday. In case of rain after Wednesday and before Sunday, the Lines and marks may get fully or partially washed off. If the umpire decides that the pitch is fit enough to play and applies the BTCL playing condition, both clubs must play a minimum of 10 overs. Umpires' decisions shall be final, and there cannot be any arguments with the umpire; both captains should ensure that both teams comply with the umpire’s decision.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">General</li>
    <ul class="ul1">
      <li class="li9">In the event of rain delaying or interrupting a match, the home team is responsible for making every effort to make play possible.</li>
      <li class="li9">Teams must not take the field before the umpire(s) at the start of the match or after any interval.</li>
      <li class="li9">All players, including substitutes, must wear conventional cricket clothing when taking part in the game. Captains are wholly responsible for enforcing this.</li>
      <li class="li9">Excessive appealing – <span class="s1">Follow MCC rules - Appendix B.</span></li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Quality of Match Day Food</li>
    <ul class="ul1">
      <li class="li9">Always include a vegetarian option.</li>
      <li class="li9">Away team to inform the home regarding any special dietary requirements <br>
(veg, halal etc.).</li>
      <li class="li9">The home team is responsible for providing the food for both teams, as per the prior Covid rule (AGM December 2024 adoption for 2025 season).</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Umpires and Scorers</li>
    <ul class="ul1">
      <li class="li50">Teams that fail to provide a scoreboard, 30-yard circle and boundary markers will be deducted points for each offence in the match concerned.</li>
      <li class="li50">Clubs that fail to provide hot tea or facilities to have tea will be deducted 2 points per match.</li>
      <li class="li50">Umpire(s) must wear appropriate dress code to maintain the standard of the game (all umpires should wear BTCL or ECB-approved uniforms).</li>
      <li class="li50">Member Clubs should pay one umpire each.</li>
      <li class="li50">If only one umpire is present, he will officiate at the bowling end throughout, receiving a normal fee; the Member Clubs will share the cost.</li>
      <li class="li50">The BCTL shall be responsible for providing the umpire/s. It shall be the responsibility of the home club to ensure that the umpire's fees are paid before the toss, the cost being shared by both clubs.</li>
      <li class="li50">If the umpire's fee is not paid on the day, the disciplinary committee will act.</li>
      <li class="li50">If an umpire travels to the ground and play does not take place, then the full fee must be paid by the teams.</li>
      <li class="li50">If both Member Clubs agree that a match is to be cancelled due to inclement weather, the home club must inform both umpires of the cancellation no later than three hours before the scheduled start.</li>
      <li class="li50">The umpire must advise the Secretary within 48 hours of the match concerned of:</li>
      <ul class="ul1">
        <li class="li9">A delay in resuming play after tea because of non-payment of an umpire.</li>
        <li class="li9">All late starts and unusual incidents are not in the best interests of the league</li>
        <li class="li9">Clubs with less than one sightscreen</li>
        <li class="li9">Teams taking longer than the permitted time for the innings.</li>
        <li class="li9">Member Clubs with less than two sight screens, unless they have dispensation from the league.</li>
        <li class="li9">Teams that do not provide a scorer for the whole game.</li>
        <li class="li9">Teams that have fewer than 11 players.</li>
        <li class="li9">Unmarked or incorrectly marked creases.</li>
        <li class="li9">Late payment of Umpires.</li>
        <li class="li9">A copy of any disciplinary report must be sent <span class="s1">to secretary@btcluk.com</span></li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">Umpire(s) shall arrive at the ground no less than 30 minutes before the scheduled start of the match.</li>
      <li class="li51">If the officially appointed umpire is delayed, both teams must wait until 2:00 PM. If no official umpire is present by 2:00 PM, both captains mutually agree to proceed with the match by appointing a neutral umpire and committing to uphold fair play and the spirit of the game. If both teams do not agree to proceed under these conditions, the match will be deemed abandoned, and equal points will be awarded to both teams (Per AGM Dec 2025)—teams<span class="s5"> to report the incident to BTCL.</span></li>
      <li class="li9">Umpires to work with captains to finish the overs in the allotted time</li>
      <li class="li9">If a player umpire (i.e., from the batting side) acts as a leg umpire, then he can only provide his verdict on the following instances:</li>
      <ul class="ul1">
        <li class="li9">Run out</li>
        <li class="li9">Stumped out</li>
      </ul>
      <li class="li9">A player umpire may always assist the main umpire but not interfere with the decision of the main umpire under any circumstances (except see above).</li>
      <li class="li9">As leg umpires constantly change, it will be up to the league umpire to brief the leg umpire each time they change.</li>
      <li class="li9">Umpire(s) shall not allow persistent interference from batting team members (including playing umpire) as advisors or refreshment providers. Umpire(s) shall call for a maximum of TWO drinks break unless otherwise agreed, based on weather conditions or the player’s condition.</li>
      <li class="li9">Umpire(s) to complete the checklist provided by BTCL. This includes, but is not limited to, the number of players, start time, tea time, and when play is completed</li>
      <li class="li9">Umpire(s) shall NOT check player IDs but provide evidence in player registration issues.</li>
      <li class="li9">New umpire rating to identify the best umpires in the league.</li>
    </ul>
  </ul>
</ul>

<p class="p9"><span class="s1">Absence of Umpire</span></p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">In the event of no panel umpire available, both teams can agree and use their player or non-player umpires (This is at their own discretion).If any disputes arise from the use of their own umpires during the game, the match will be considered abandoned, and 10 points will be awarded to each team.</li>
      <li class="li9">If the teams did not or could not agree on playing without the league umpire, 10 points will be awarded for each team (as an abandoned game due to the umpire not being present).</li>
      <li class="li9">If any wrongdoing is proven, BTCL reserves the right to take disciplinary action against the offending team(s) or individual(s).</li>
      <li class="li9">Spirit of Cricket by ECB rules should be adhered to and understood in this scenario.</li>
    </ul>
  </ul>
</ul>
<p class="p9"><span class="s1">Bribing a Umpire</span></p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">If any wrongdoing is proven, BTCL reserve the right to take disciplinary action against the offending teams or individuals.</li>
      <li class="li9">Spirit of Cricket by ECB rules should be adhered to and understood in this scenario.</li>
    </ul>
  </ul>
</ul>

<p class="p25"><span class="s1">If the umpire is found unfit to officiate</span></p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">In case BTCL receives three complaints from member clubs in a season, the umpire will be banned by BTCL on proof. When the first complaint is received, BTCL should investigate with both home and away teams.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li12">The Bowling of Fast Short-Pitched Balls (The Bouncer)<br>
9.20.1 Law 41.6 is amended to read as follows:</li>
    <ul class="ul1">
      <ul class="ul1">
        <li class="li9">A bowler shall be limited to two fast short-pitched balls per over. The Umpire at the bowler’s end will make it clear to both the bowler and the batsmen at the wicket when such a delivery within this limit is bowled. This ruling shall apply even though the striker has made the ball with his bat, person, or equipment.</li>
        <li class="li9">A fast short-pitched ball is defined as one that passes or would have passed over the height of the batsman standing upright at the crease. The Umpire shall call and signal no ball on each occasion the limit is exceeded. In addition, the Umpires will adopt the procedures of Law 41.6</li>
        <li class="li9">In addition, a ball that passes above head height, which prevents the batsman from being able to hit it with his bat by means of a normal cricket stroke, shall be called a no-ball. For the avoidance of any doubt, any fast short-pitched delivery that is called a no-ball under these playing conditions shall also count as one of the fast short-pitched deliveries in that over. </li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">No Ball/Wide Ball</li>
    <ul class="ul1">
      <li class="li23">No Ball – bowling of high, full-pitched balls</li>
      <ul class="ul1">
        <li class="li9">Any delivery which passes or would have passed above the full above waist height of the striker standing upright at the crease is to be deemed dangerous and unfair, whether or not it is likely to inflict physical injury on the striker, and shall be called No Ball (see other No ball interpretation on Laws of Cricket).</li>
      </ul>
    </ul>
  </ul>
</ul>
<p class="p38"><span class="s1">Note</span> Medical definition of waist - The part of the human trunk between the bottom of the rib cage and the pelvis.</p>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <ul class="ul1">
        <li class="li9">A penalty of one run shall be awarded instantly on the call of No Ball. A No Ball shall not count as one of the over.</li>
        <li class="li9">No Ball (Free Hit) (Law 41.7) – Free Hit following any delivery following a no ball shall be a free hit for whichever batsman is facing it. Field changes are not permitted for free hit deliveries unless there is a change of striker or unless the no-ball was called for an infringement of the fielding regulations, in which case the field may move to the minimum necessary to make the new field legal. However, in all circumstances, any fielder within 15 yards of the striker may retreat to a position on the same line no more than 15 yards. The batsman cannot be out caught, stumped, or bowled but can be run out.</li>
      </ul>
      <li class="li23">Wide Ball</li>
    </ul>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <ul class="ul1">
        <li class="li9">If the bowler bowls a ball, not being a No Ball, the umpire shall adjudge it a Wide if, according to the definition in (c) below, in his opinion, the ball passes wide of him standing in a normal guard position.</li>
        <li class="li9">The ball will be considered as passing wide of the striker unless it is sufficiently within his reach for him to be able to hit it with his bat by means of a normal cricket stroke.</li>
        <li class="li9">BTCL umpires are instructed to apply a very strict and consistent interpretation of this law to prevent negative bowling wide of the wicket. Any offside delivery shall be judged in accordance with (a) and (b) above. Any leg-side delivery that passes the leg side of the striker and misses the leg stump shall be called a wide.</li>
        <li class="li9">The umpire shall not adjudge a delivery as being a Wide: </li>
        <ul class="ul1">
          <li class="li9">If the striker, by moving, either causes the ball to pass wide of him, as defined in (c) above, or brings the ball sufficiently within his reach to be able to hit it with his bat by means of a normal cricket stroke. </li>
        </ul>
        <li class="li9">If the ball touches the striker’s bat or person.</li>
        <li class="li9">The ball does not become dead on the call of Wide Ball.</li>
        <li class="li9">A penalty of one run shall be awarded instantly on the call of Wide Ball.</li>
        <li class="li9">A Wide shall not count as one of the over.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Offensive Language by Player/Umpire</li>
  </ul>
</ul>
<p class="p52">9.22.1 Follow ECB guidelines and umpires to enforce this. Any evidence will be used to identify persistent offenders (applies to both players and umpire behaviour).</p>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Physical Violence of Player(s)/Umpires</li>
    <ul class="ul1">
      <li class="li9">Follow ECB guidelines and umpires to enforce this.</li>
      <li class="li9">Police intervention may be needed.</li>
    </ul>
  </ul>
</ul>

<p class="p23">10. SCORE SHEET UPDATE</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li9">Live scoring at play cricket shall be mandatory from the 2026 season. Any team that fails to submit live scoring for a match will incur a two-point penalty (Per the AGM Dec 2025 adoption).</li>
  </ul>
</ul>

<p class="p32">11. POINTS SYSTEM</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li32">General</li>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">Points will be awarded considering the whole season games are played by the teams as follows:</li>
      <ul class="ul1">
        <li class="li12">The winning team shall receive 20 points.</li>
        <li class="li12">The losing team shall receive 1 batting point for every 40 runs scored, with a maximum of 5 batting points. (For interrupted matches, the calculation is based on the number of overs played. E.g., if the team plays 32 overs, then for every 32 runs, 1 point will be provided as a losing point up to a maximum of 5 points.</li>
        <li class="li9">The losing team shall receive 1 bowling point for every 2 wickets taken (maximum of 5 points).</li>
        <li class="li9">In the event of a tied match where both sides have scored the same number of runs, then each side shall be awarded 10 points.</li>
        <li class="li9">In the event of two or more sides finishing with an equal number of points, then their final positions will be decided on a net run rate basis (see Appendix A).</li>
        <li class="li9">If the match is abandoned, then both teams receive 10 points (AGM/SGM 2024 adoption).</li>
        <li class="li9">The bowling side will get full bowling points (5 points) if they get the opposition all out, even though the batting side has fewer than 11 players.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Promotion and Relegation</li>
    <ul class="ul1">
      <li class="li9">Generally, Two Member Clubs will be promoted and relegated throughout the divisions each season. This is based on the accumulated points published on the League website.</li>
      <li class="li9">BTCL-COM has the right to change the promotion and relegation criteria if it feels necessary to keep the maximum number of clubs playing in any division.</li>
      <li class="li9">If a club withdraws from the league before the start of a new season (before 31<sup>st</sup> March), the club next in line from the previous year's league table will be promoted.</li>
      <li class="li9">If a club withdraws from the league during an active season, every match the club played and to be played will be made void. The points from those matches will be set to zero either in advance or retrospectively.</li>
      <li class="li9">A team should play 50% of their scheduled matches; if not, they will be disqualified, and they have to start from the bottom of the league in the following year.</li>
      <li class="li9">If any clubs failed to pay the grounds fee, umpire fees, or any other fees, they shall not be considered for promotion or other league awards. These clubs will be relegated to the lower division or removed from the league.</li>
    </ul>
  </ul>
</ul>

<p class="p23">12. LEAGUE AWARDS</p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Annual Award Ceremony</li>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">The award ceremony for the league will be followed by the completion of the season. BTCL-COM will decide on the venue &amp; date and will be empowered to select an appropriate name for the ceremony. </li>
    </ul>
    <li class="li23">Awards Selections </li>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <ul class="ul1">
      <li class="li9">Awards selections are based on a recorded entry on the BTCL official website, and clubs must take responsibility to check the league tables and individual performance on the BTCL official website. After a specified date, all the scores will be made final, and no amendments will be allowed. </li>
    </ul>
  </ul>
</ul>
<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Division Awards</li>
    <ul class="ul1">
      <li class="li9">Each division in the league awarded two awards:</li>
      <ul class="ul1">
        <li class="li9">Challenge cup</li>
        <li class="li9">Prize money</li>
      </ul>
      <li class="li9">The above awards are presented to champions and runners-up in the league. BTCL-COM is empowered to decide on prize money and the number of trophies awarded in the league. If required, BTCL-COM will award other clubs in the league for good performance.</li>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Individual/Team Awards</li>
    <ul class="ul1">
      <li class="li9">From time to time, the league will announce team and individual awards based on merit. The following individual awards have been identified by the league, but are not limited to: BTCL-COM may change the title and number of awards.</li>
      <ul class="ul1">
        <li class="li9"><span class="s1">Best Bowler in Division</span> - highest aggregate of wickets in League matches only.</li>
        <li class="li9"><span class="s1">Best Batsman in Division</span> - highest aggregate of runs in League matches only.</li>
        <li class="li9"><span class="s1">Best All-Rounder in Division</span> - selected by batting and bowling performances.</li>
        <ul class="ul1">
          <li class="li9">The eligibility cut-off for the All-Rounder award shall be a minimum of 200 runs scored and 15 wickets taken during the season (As per AGM Dec 2025 adoption).</li>
        </ul>
        <li class="li9"><span class="s1">Junior Player of the Year</span> - most outstanding junior performance.</li>
        <li class="li9"><span class="s1">Fair Play Award</span> - determined by umpires.</li>
      </ul>
    </ul>
  </ul>
</ul>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Merit Award Prizes</li>
  </ul>
</ul>
<p class="p53">Where the minimum cutoff for runs scored and wickets taken is not met within a division, the top five run-scorers and wicket-takers in that division will be taken into consideration for Best Batsman, Best Bowler, and Merit Awards (As per AGM Dec 2025 adoption).</p>

<ul class="ul1">
  <ul class="ul1">
    <li class="li23">Social Media</li>
    <ul class="ul1">
      <li class="li9">Any abuse in social media or by any other medium will result in disciplinary action by BTCL.</li>
      <li class="li9">Develop a social media policy for teams and players.</li>
      <li class="li9">Minimum 7 players to be present to receive awards (applies to 1st,2nd &amp; 3rd).</li>
      <li class="li9">Failure to attend the event, an additional four ticket prices will be charged to the club (applies to 1st, 2nd &amp; 3rd), unless a valid reason is submitted with evidence.</li>
      <li class="li9">Trophies will not be given to clubs if they fail to attend the presentation night.</li>
      <li class="li9">Failure to return the returnable trophies to BTCL will lead to a fine.</li>
    </ul>
  </ul>
</ul>

<p class="p23">13. ECB SAFE HANDS POLICY </p>
<ul class="ul1">
  <ul class="ul1">
    <li class="li12"> The League has adopted the ECB Safe Hands Policy in total to pursue safe environments for young and disadvantaged people within the League’s Member Clubs. <span class="s6">https://www.ecb.co.uk/safeguarding</span></li>
    <li class="li12"> Unless otherwise specified in the BTCL playing condition, the generally accepted laws of cricket shall apply. <span class="s6">http://www.lords.org/laws-and-spirit/laws-of-cricket/laws/</span>Also, refer to the changes in law <span class="s6">http://playerbehaviour.ecb.co.uk/#/</span></li>
  </ul>
</ul>


<p class="p32">APPENDIX</p>
<p class="p32"><span class="s1">APPENDIX A – RUN RATE</span></p>

<ul class="ul1">
  <li class="li9">Run Rate</li>
</ul>
<p class="p9">Total Runs / Total number of overs, e.g., a team batted first and was all out in 25 overs in a 35-over match; then the total number of overs is 35, not 25.</p>
<p class="p9">For teams batting second and reaching their target in 26 overs, the total number of overs is 26.</p>

<ul class="ul1">
  <li class="li23">Net Run Rate </li>
</ul>
<p class="p9">If the team batting first scored 210 runs in 35 overs, the run rate is 6. Suppose the second team scored 175 all out in 32.4 overs; their run rate is 5.4.</p>

<p class="p9">The NET RUN RATE for the team that batted first is +0.6, and the second team is -0.6. </p>

<p class="p9">Should the team batting second manage to reach their target (211 runs) in 34.4 overs, their run rate would be 6.134.</p>
<p class="p9">The net run rate in this instance would be the team that batted first is -0.134, and the second team get +0.134</p>

<ul class="ul1">
  <li class="li23">Net Run Rate (NRR)</li>
</ul>
<p class="p9">Play Cricket will calculate NRR.</p>

<p class="p32"><span class="s1">APPENDIX B - ECB Helmet &amp; Fast Ball Directives for Young Players</span></p>
<ul class="ul1">
  <li class="li57">ECB Helmet Directive</li>
</ul>
<p class="p50">The ECB Helmet Safety directives for young players up to age 18 will apply to all league matches. Captains are required to ensure that young players wear a helmet when batting and when standing up to the stumps when keeping wicket.</p>
<ul class="ul1">
  <li class="li50">ECB Fast Ball Directive</li>
</ul>
<p class="p57">The ECB Fast Bowling Directives for young fast bowlers up to and including the under-19 age group will apply to all league matches. In those matches to which panel umpires have been appointed, it is the responsibility of each captain to inform the umpires, before the start of the match, the names and relevant age group of any fast bowlers under the age of 19; Age groups are based on the age of the player at midnight on 31<sup>st </sup>August in the year preceding the current season Captains are required to ensure that any fast bowler under the age of 19 does not exceed the ECB directives for a maximum over’s and the minimum rest periods (See below). Panel umpires will monitor these requirements:</p>
<ul class="ul1">
  <li class="li58">Age Max Overs Per Spell Max Over Per Day</li>
</ul>
<p class="p58">Up to U13 &amp; U14 &amp; U15 &amp; U16 &amp; U17 &amp; U18</p>
<ul class="ul1">
  <li class="li58">Fielding Directive</li>
</ul>
<ul class="ul1">
  <li class="li57">No young player in the U15 age group or younger shall be allowed to field closer than 8 yards (7.3m) from the middle stump, except behind the wicket on the off side, until the batsman has played at the ball.</li>
  <li class="li9">For players in the U13 age group and below, the distance is 11 yards (10 metres).</li>
  <li class="li9">These minimum distances apply even if the player is wearing a helmet.</li>
  <li class="li9">Should a young player in these age groups come within the restricted distances of the umpire?</li>
  <li class="li9">Must stop the game immediately and instruct the fielders to move back.</li>
  <li class="li9">In addition, any young player in the U16 to U18 age group, who has not reached the age of 18, must wear a helmet and, for boys, an abdominal protector (box) when fielding within 6 yards (5.5 metres) of the bat, except behind the wicket on the offside. Players should wear appropriate protective equipment whenever they are fielding in a position where they feel at risk.</li>
  <li class="li9">These fielding regulations apply to all cricket in England and Wales. Age groups are based on the player's age at midnight on 31st August in the year preceding the current season.</li>
</ul>

<p class="p60"><span class="s1">SGM 2023 amendments</span></p>
<p class="p61"><b>From 2023:</b></p>

<p class="p61"><b>Proposals to implement from 2023 Season</b><span class="s9"><b> (the p</b></span><span class="s10"><b>oints approved @SGM on 16/04/23</b></span><span class="s9"><b>)</b></span></p>

<p class="p62"><span class="s1"><b>Player Registration</b></span>:</p>

<ul class="ul1">
  <li class="li64">Player Transfer - <b>Allow Home players who are 50 and over</b> to be freely interchanged among teams in the same club (Playing Condition 8.7 states only U19 players can be interchanged freely)<span class="s9">.</span></li>
</ul>

<ul class="ul1">
  <li class="li66">Penalty points given for any complaint received after one week of the end of the season should be imposed in the following season.</li>
</ul>

<ul class="ul1">
  <li class="li66">If a team violates the players’ rules and is relegated from the division, BTCL should impose a <b>20 penalty points</b> against the team for the following season.</li>
</ul>

<ul class="ul1">
  <li class="li67">The <b>player transfers to extend that to 30 April.</b></li>
</ul>

<ul class="ul1">
  <li class="li67">The <b>player transfer comes under the 7-day rule like new home players</b>. (<span class="s11">The 7-day window rule only applies to players who have not played any matches that season. </span> All the clubs that the player transferred to are now aligning with the 7-day rule for registering new home players. Player transfers will follow the 7-day transfer rule agreed at the 2023 SGM; hence, the transfer window is no longer relevant.</li>
</ul>

<p class="p69"><b>Player transfer between clubs:</b></p>

<ul class="ul1">
  <li class="li67">If a player wishes to transfer from one club to another, the following actions need to take place.</li>
</ul>
<p class="p69">a. <span class="s9">The player in question needs to inform in writing by email to the current club, the new club and to BTCL (info@btcluk.com) with the following text, “</span><span class="s12"><i>I [Player’s full name] with BTCL player id [insert BTCL player id] wish to transfer from [insert current team name/club name] to [insert new team name/club name]</i>. </span>The contact email addresses for the clubs must be obtained from the BTCL website, and team and club names should match those listed there.  Any anomalies or omissions will lead to the request being rejected.</p>

<p class="p70"><span class="s13">b. </span>If the transfer is requested in mid-season, the player must confirm that he has not played any games in the current season for the current club by inserting the text “<span class="s12"><i>I also confirm that I have not played any matches for the [insert current team/club name]</i>”</span><span class="s13">.  Failure to confirm this will lead to the transfer request being rejected.</span></p>

<p class="p70"><span class="s13">c. </span>In addition, BTCL expects the new club to verify that the player has not played any games in the current season. If a player has played any game(s) in the current season, he cannot be transferred to the new club.  The new club must also verify the eligibility criteria of the player being transferred by verifying the necessary documents.</p>

<p class="p70"><span class="s13">d. </span>BTCL will action the transfer and inform in writing to the current club, the new club and the player by return email.</p>

<p class="p70"><span class="s13">e. </span>The new club must then follow the transfer process within Play Cricket to transfer the player to them.  BTCL does not take the responsibility for changes in Play Cricket and expects the player record to be correct before the commencement of a match in which the player is due to take part.</p>

<p class="p70"><span class="s13">f. </span>If any breaches are found in the above process, BTCL reserves the right to take action against the offending team(s)/club(s) or the player.</p>

<p class="p70"><span class="s13">g. </span>A player is allowed a maximum of two transfers in a calendar year to minimise the workload on BTCL.</p>

<p class="p70"><span class="s1"><b>Player transfer within a club (i.e., between the teams of a club)</b></span></p>

<p class="p70"><span class="s13">a. </span>A player can be transferred from one team to another within the club, provided that he has not played any games for the current team.</p>

<p class="p70"><span class="s13">b. </span>If a player registered for the ‘A’ team of the club, but only played for the ‘B’ team of the club during the 1<sup>st</sup> half of the season, the club can transfer the player from the ‘A’ team to the ‘B’ team at any point after 1<sup>st</sup> half of the season.</p>

<p class="p70"><span class="s13">c. </span>The clubs can do this action by using their team login on the BTCL website.</p>

<p class="p70"><span class="s13">d. </span>If any breaches are found in the above process, BTCL reserves the right to take action against the offending team(s)/club(s).</p>

<ul class="ul1">
  <li class="li67">Home player category - Amended text approved at the SGM. </li>
</ul>
<p class="p72">8.4 A team can register up to TWO “non-home” players; however, only ONE “non-home” player can play in a match. A home player is defined as a Sri Lankan Tamil or of Sri Lankan Tamil heritage (one parent is a Sri Lankan Tamil) who has the right to remain in the UK.  A player can play under the category of “home player” by providing evidence in an unequivocal form that he is a Sri Lankan Tamil or of Sri Lankan Tamil heritage.   If such evidence is not forthcoming, other evidence may be considered at the discretion of the BTCL Committee, but BTCL reserves the right to request original documentation if deemed necessary.</p>

<p class="p61"><span class="s1"><b>Scorecard &amp; Awards:</b></span></p>

<ul class="ul1">
  <li class="li67">If the disciplinary committee proves a complaint against a player, they<b> will not qualify for any awards at the BTCL Cricketers Night</b>.</li>
</ul>

<ul class="ul1">
  <li class="li67"><b>Scorecard altered by the club in favour of a player shouldn’t qualify for any awards at the BTCL Cricketers Night</b>.</li>
</ul>

<ul class="ul1">
  <li class="li67"><b>Overseas players</b> shouldn’t be <b>nominated for any award category</b>.</li>
</ul>
<p class="p75"><b>SGM Decision: </b>This result can be negative; therefore, they are qualified regardless of the category.</p>

<ul class="ul1">
  <li class="li67">BTCL should Introduce Financial awards for Fair Play.</li>
</ul>

<ul class="ul1">
  <li class="li67">If <b>scorecard alteration/tampering is proven, the relevant team should get a 20-point deduction</b> in the relevant match, and the <b>captain should be banned for 2 games</b>.</li>
</ul>


<p class="p77"><span class="s1"><b>Match Day &amp; AOB:</b></span></p>
<ul class="ul1">
  <li class="li67"><b>Players’ photos MUST be produced on the BTCL website</b></li>
  <ul class="ul1">
    <li class="li67">Any player without a photo shouldn’t play the match.</li>
    <li class="li67">All Under-18 players must comply with one of the following requirements:</li>
    <li class="li67">Have a recent photograph uploaded on the BTCL website along with a valid photo ID, or</li>
    <li class="li67">Submit a signed consent letter from a parent or guardian if they do not wish their photo to be uploaded. If a player’s photo is not uploaded on the BTCL website, the player must carry a valid photo ID to every match. The umpire or the opposition captain may check this ID.</li>
    <li class="li67">No photo ID = No game.</li>
  </ul>
</ul>
<ul class="ul1">
  <li class="li66">If a team pulls out after confirming participation in the league fixtures <span class="s1"><b>AND </b></span>after fixtures have been published, there will be a club-level penalty of 20 points to the relevant club for the same year or the following season.</li>
</ul>

<ul class="ul1">
  <li class="li66">If a <b>team pulls out and that club has one team in the league, they should rejoin at the bottom division</b> if they choose to come back to BTCL.</li>
</ul>

<ul class="ul1">
  <li class="li66">No games can be moved at any stage once the fixtures have been released.  Games in any season that cannot be played for any reason should be classified as abandoned (unless a walkover).</li>
</ul>

<ul class="ul1">
  <li class="li66">Increase the <b>walkover points deduction to 40 points per game for the last 2 games of the season</b>, and those points are to be carried forward to the next season.</li>
</ul>

<p class="p61"><b>From 2024:</b></p>

<p class="p61"><b>Proposals to implement from 2024 Season</b><span class="s9"><b> (the points a</b></span><span class="s10"><b>pproved @SGM on 16/04/23)</b></span></p>

<ul class="ul1">
  <li class="li67">“<b>Overseas category</b>” 1<sup>ST</sup> classes players, who have played a 1st-class game in the last 12 months (last 12 months count from 1st of May previous year till 30th April current year), cannot play in the BTCL league.</li>
</ul>

<ul class="ul1">
  <li class="li67">“<b>Home category</b>” 1<sup>st</sup> class players who have played a 1<sup>st</sup> class game in the last 12 months (<b>last 12 months count from 1<sup>st</sup> of May previous year till 30<sup>th</sup> April current year)</b> can play in the BTCL league (This will include 1<sup>st</sup> class players who are potentially of mixed heritage, such as Sinhalese/Tamil, English/Tamil, etc.).</li>
</ul>

<ul class="ul1">
  <li class="li67">Overseas players should not be allowed in the 100-ball tournament.</li>
</ul>

<p class="p80"><b>Note: the point to discuss again is AGM 2024.</b></p>

<ul class="ul1">
  <li class="li66">Overseas players should not be allowed except in Premier &amp; Super Divisions.</li>
</ul>

<p class="p80"><b>@SGM, a few teams suggested discussing this point again at the upcoming AGM 2024.</b></p>

<p class="p83"><b>BTCL suggested sending us the disagreement proposal against the above point.</b></p>


<p class="p60"><span class="s1">AGM/SGM - 2024 Amendments</span></p>

<ul class="ul1">
  <li class="li70">Overseas players should be allowed to play in all divisions.</li>
  <li class="li70"><span class="s3">A player (Home and non-home) cannot have played a first-class game in the last 12 months (defined as 12 months immediately before the start of the current season, which is the date of the first match of the season).</span>This has been removed from the 2025 season – See below)</li>
  <li class="li70">If a team can't play a match, it should inform the BTCL secretary/ umpire coordinator/ scorecard secretary and opponent team manager by at least Wednesday 6:00 pm before the said date. If the team fails to do so, it is liable for the full umpire payment.</li>
  <li class="li70">Home ground details must be updated on the Play Cricket website by 6:00 pm on Monday, or the reason for not doing so by 6 pm on Monday. Failure to do so will result in a five-point penalty in the current season.</li>
  <ul class="ul1">
    <li class="li70">All ground detail changes must be communicated by email to the BTCL Fixture Secretary and the opposing team. Notifications made by phone or text message will not be accepted. Failure to comply will result in a five-point penalty being imposed on each occasion (per the AGM Dec 2025 adoption).</li>
  </ul>
  <li class="li70">Home Player—Once BTCL approves the player's status, it should not investigate the same player again.</li>
  <li class="li70">Member clubs' queries must be sent to the BTCL Secretary in writing; BTCL no longer accepts verbal communications.</li>
  <li class="li70">Amend 9.16.4 to allow grounds to be within a 15-mile radius outside of M25.</li>
  <li class="li70">The Home team may be responsible (only if required) for paying the umpire an additional £20.00 to £30.00 for their fuel cost.</li>
  <li class="li70">The matches can't start earlier than the scheduled time mentioned in the BTCL playing conditions.</li>
  <ul class="ul1">
    <li class="li70">If the teams want to start earlier than the scheduled time, both teams must send written approval from the BTCL fixture secretary by Wednesday at 6:00 pm.</li>
  </ul>
  <li class="li70">If the official match umpire calls off the match due to the unfit pitch, the game cannot continue under any circumstances. The match should be treated as abandoned.The full umpire fee is due (per the adoption at the AGM in Dec 2025).</li>
  <li class="li70">If the pitch is not fit to play for any reason, neither team can request to change the ground on match day. The match will be awarded to the away team.</li>
  <li class="li70">All abandoned matches should be awarded 10 points, including the season's last two games</li>
  <li class="li70">Advance notice of a player suspension—The BTCL disciplinary committee must give the respective team and the player a minimum of 7 days' notice before suspending any player.</li>
</ul>
<p class="p70">Set dates for match disputes</p>
<ul class="ul1">
  <li class="li70">Teams should inform BTCL in writing by Monday midnight</li>
  <li class="li70">By Tuesday midnight, the BTCL Committee should decide whether it is disciplinary or BTCL COM action.</li>
  <li class="li70">If the opposition is required to send their statements, they should be requested by the BTCL secretary by Tuesday night to respond by the opposition team by Wednesday midnight.</li>
  <li class="li70">The disciplinary committee should meet by midnight on Wednesday.</li>
  <li class="li70">If the disciplinary committee decides to hold the hearing, relevant clubs should be prepared for the hearing on Thursday.</li>
  <li class="li70">The disciplinary committee should decide on their final version by Friday midnight.</li>
</ul>

<p class="p70"><b>Standard Penalties introduction for</b></p>
<p class="p70">Violence, including verbal abuse –</p>
<ul class="ul1">
  <li class="li70">Introduce standard penalties aligned to RCR in our Playing Conditions. Once this is breached, the penalty is automatically applied with no appeal.</li>
  <li class="li70">Violations in player registration</li>
  <li class="li70">Scorecard tampering &amp; violations </li>
  <li class="li70">BTCL Awards criteria (Merit rules)</li>
  <li class="li70">Three-member disciplinary appeal panel introduction</li>
</ul>

<p class="p70"><b>BTCL's future recommendations</b></p>
<ul class="ul1">
  <li class="li70">The home team should pay the umpire fee on the day to the umpire, and the away team fee payable by BTCL upon receiving the umpire's full report within three days. So, every team should pay BTCL in advance for the seven matches' umpire fees, and BTCL will pay the umpire. Any disputed match will be payable upon full coordination of the umpire for an enquiry.</li>
  <li class="li70">A 3-member executive panel (Executive committee and one governor) to decide inward and outward communications. They are also responsible for allocating the club's requests and disputes.</li>
  <li class="li70">An umpire must write their match report to the BTCL secretary within 24 hours of the match's conclusion.</li>
  <li class="li87">If umpires fail to do so, BTCL should impose a 2-match suspension to officiate in a league match. The written report is an acceptable resource; however, if any umpires struggle with writing, they can submit a voice-recorded report.</li>
</ul>

<p class="p60"><span class="s1">AGM – December 2024 Amendments (for 2025 Season)</span></p>

<ul class="ul1">
  <li class="li66">All players (including home and overseas players) should be allowed to play without any restrictions in the 2025 season. This includes removing the ban on 1st-class players who have played a 1st-class game in the last 12 months.</li>
  <li class="li66">The BTCL umpire fees increase to £80.00 from the 2025 season onwards.</li>
  <li class="li66">Fair Play Award—introduced by BTCL from the 2025 season onwards. Further details will be published before the season starts.</li>
  <li class="li66">Best Fielder Award introduced by BTCL from the 2025 season onwards. Further details will be published before the season starts.</li>
  <li class="li66">The home team is responsible for providing the food for both teams, as was the case before the COVID rule.</li>
  <li class="li66">Walkover: All walkover matches must be reported to BTCL by Wednesday midnight @12:00; otherwise, -20 points carry forward to next season.</li>
</ul>
<p class="p89">7 days before match day, the players must register and obtain approval on the BTCL website and the Play Cricket platform. </p>
</div>`;
